import { Checkbox, withStyles } from "@material-ui/core";
import { inject } from "mobx-react";
import { observer } from "mobx-react-lite";
import React from "react";

const tempos = [
  { tempo: "Basal", minutos: "basal",checked: true },
  ...Array.from({ length: 36 }, (obj, index) => {
    return {
      tempo: `${(index + 1) * 5} min`,
      minutos: `${(index + 1) * 5}`,
      checked: false,
    };
  }),
  { tempo: "180 min", minutos: 180, checked: false },
  { tempo: "200 min", minutos: 200, checked: false },
  { tempo: "210 min", minutos: 210, checked: false },
  { tempo: "240 min", minutos: 240, checked: false },
  { tempo: "300 min", minutos: 300, checked: false },
  { tempo: "360 min", minutos: 360, checked: false },
  { tempo: "420 min", minutos: 420, checked: false },
  { tempo: "480 min", minutos: 480, checked: false },
  { tempo: "540 min", minutos: 540, checked: false },
  { tempo: "600 min", minutos: 600, checked: false },
  { tempo: "800 min", minutos: 800, checked: false },
  { tempo: "900 min", minutos: 900, checked: false },
  { tempo: "940 min", minutos: 940, checked: false },
  { tempo: "960 min", minutos: 960, checked: false },
  { tempo: "1320 min", minutos: 1320, checked: false },
  { tempo: "1380 min", minutos: 1380, checked: false },
  { tempo: "1440 min", minutos: 1440, checked: false },
  { tempo: "Pós-prandial", minutos: "pos-prandial", checked: false },
];

const TesteCurvas = observer(({ classes, exameStore }) => {
  const onChange = async (event, curva) => {
    const isChecked = event.target.checked;

    const curvasSelecionadas = exameStore?.exame?.curvas || [];

    const existe = curvasSelecionadas.find(
      (item) => item.minutos === curva.minutos
    );

    let novasCurvas;

    if (isChecked && !existe) {
      novasCurvas = [
        ...curvasSelecionadas,
        { minutos: curva.minutos, checked: true },
      ];
    } else if (!isChecked && existe) {
      novasCurvas = curvasSelecionadas.filter(
        (item) => item.minutos !== curva.minutos
      );
    } else {
      return;
    }

    await exameStore.changeDadosExame(novasCurvas, "curvas");
  };
  return (
    <div className={classes.curvas}>
      <div className={classes.title}> PERÍODOS DE CURVAS</div>
      {
        <div className={classes.contentCurvas}>
          {tempos.map((intervalo, index) => {
            const isChecked = exameStore?.exame?.curvas?.some(
              (item) => item.minutos === intervalo.minutos && item.checked
            );
            return (
              <div className={classes.checkbox} key={index}>
                {" "}
                <Checkbox
                  id={`pac-tcv-chk-crv-${index}`}
                  color="primary"
                  onChange={(e) => onChange(e, intervalo)}
                  checked={isChecked}
                  disabled={intervalo?.disabled || intervalo.tempo === "Basal"}
                />
                <p className={classes.paragrafo}>{intervalo.tempo}</p>
              </div>
            );
          })}
        </div>
        
      }

      <div className={classes.spanAviso}>
        * Selecione pelo menos dois períodos
      </div>
    </div>
  );
});

const styles = {
  contentCurvas: {
    display: "grid",
    gridTemplateColumns: "repeat(7, 1fr)",
    gridTemplateRows: "repeat(8, 27px)",
    textWrap: "nowrap",
  },
  checkbox: {
    display: "flex",
    alignItems: "center",
    fontSize: "12px",
    color: "#505050",
  },
  paragrafo: {
    fontSize: "10px",
  },
  title: {
    color: "#219A97",
    fontSize: "12px",
    fontWeight: 600,
  },
  curvas: {
    padding: "10px",
  },
  spanAviso: {
    color: "#868686",
    fontSize: "12px",
    marginTop: "5px",
  },
};

const TesteCurvaWithStyles = withStyles(styles)(TesteCurvas);
const stores = ["exameStore"];
export default inject(...stores)(TesteCurvaWithStyles);
